module.exports = __webpack_public_path__ + "static/media/02.c721d350.jpg";